import { uuid, refresh, logout } from "@/services/helpers";

import dayjs from "@/services/dayjs";

export default {
  install(App) {
    App.config.globalProperties.$laravel = window.Laravel;
    App.config.globalProperties.$laravel.route = window.route;

    App.config.globalProperties.$uuid = uuid;
    App.config.globalProperties.$logout = logout;
    App.config.globalProperties.$refresh = refresh;

    App.config.globalProperties.$dayjs = dayjs;
  }
};
